import React from "react";
import plus from "../assets/plus big.png";
import marketing from "../assets/marketing-kit.png";
import telemarekting from "../assets/telemarekting.png";
import posty from "../assets/posty.png";
import brochure from "../assets/brochure.png";
import image99 from "../assets/$99 value big.png";
import image49 from "../assets/$49 Com Cleaning.png";

const CONTENT = {
  en: {
    heading: "Get These",
    headingSpan: "Extras",
    headingSuffix: "With Qualified Order",
    marketingKit: <>The Commercial <br />Cleaning Marketing <br />Made Easy <br />Marketing Kit!</>,
    voiceMail: <>Bonus Voice Mail <br />Script</>,
    postcard: <>Bonus Postcard <br />Templates</>,
    brochure: <>Bonus Brouchure <br />Templates</>,
  },
  es: {
    heading: "Consigue estos",
    headingSpan: "extras",
    headingSuffix: "con pedido calificado",
    marketingKit: <>Kit de marketing de limpieza comercial <br />¡hecho fácil!</>,
    voiceMail: <>Guion de buzón de voz <br />de regalo</>,
    postcard: <>Plantillas de postales <br />de regalo</>,
    brochure: <>Plantillas de folleto <br />de regalo</>,
  },
};

const GetExtra = ({ lang = "en" }) => {
  const t = CONTENT[lang] || CONTENT.en;
  return (
    <section className="py-16 bg-[#DBE4E5]">
      <div className="container mx-auto max-w-5xl px-4 md:px-0">
        <div className="text-center mb-12">
          <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-5 justify-center sm:justify-between mx-auto">
  <img src={plus} width={200} height={125} />
  <div className="mt-4">
    <h2 className="text-3xl text-[#1465B7] font-bold">
      {t.heading} <span className="text-[#26A94A]">{t.headingSpan}</span> {t.headingSuffix}
    </h2>
  </div>
  <img src={plus} width={200} height={125} className="hidden sm:block" />
</div>

          <div className="container mx-auto max-w-5xl px-4 md:px-0 mt-8">
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-9 max-w-4xl justify-center mx-auto">
              <div>
                <div className="relative flex justify-center items-center">
                  <div className="w-40 h-40 rounded-full flex items-center justify-center  z-20">
                    <img src={image99} width={130} />
                  </div>
                  <div className="w-40 h-40 rounded-full flex items-center justify-center -ml-12 z-10">
                    <img src={marketing} width={130} />
                  </div>
                </div>
                <p className="text-[#1465B7] font-semibold text-lg leading-relaxed text-center mt-4 ml-4">
                  {t.marketingKit}
                </p>
              </div>
              <div>
                <div className="w-40 h-40 rounded-full flex items-center justify-center mx-auto">
                  <img src={telemarekting} width={130} />
                </div>
                <p className="text-[#1465B7] font-semibold text-lg leading-relaxed text-center">
                  {t.voiceMail}
                </p>
              </div>
              <div>
                <div className="w-40 h-40 rounded-full flex items-center justify-center mx-auto">
                  <img src={posty} width={130} />
                </div>
                <p className="text-[#1465B7] font-semibold text-lg leading-relaxed text-center">
                  {t.postcard}
                </p>
              </div>
              <div>
                <div className="relative flex justify-center items-center">
                  <div className="w-40 h-40 rounded-full flex items-center justify-center  z-20">
                    <img src={image49} width={130} />
                  </div>
                  <div className="w-40 h-40 rounded-full flex items-center justify-center -ml-12 z-10">
                    <img src={brochure} width={130} />
                  </div>
                </div>
                <p className="text-[#1465B7] font-semibold text-lg leading-relaxed text-center ml-6">
                  {t.brochure}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetExtra;
